import { CdkScrollable, ScrollDispatcher } from "@angular/cdk/scrolling";
import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { filter, Subject, takeUntil } from "rxjs";

@Directive({ selector: "[stickyShadow]" })
export class StickyShadowDirective implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private scrollDispatcher: ScrollDispatcher
    ) {}

    ngOnInit(): void {
        this.scrollDispatcher
            .scrolled()
            .pipe(
                filter(
                    (scrollable): scrollable is CdkScrollable =>
                        !!scrollable && scrollable.getElementRef().nativeElement.tagName === "MAT-SIDENAV-CONTENT"
                ),
                takeUntil(this.destroy$)
            )
            .subscribe((scrollable) => {
                const isScrolled = scrollable.measureScrollOffset("top") > 0;

                if (isScrolled) {
                    this.renderer.addClass(this.el.nativeElement, "shadow-active");
                } else {
                    this.renderer.removeClass(this.el.nativeElement, "shadow-active");
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
